import { EnhancedWithAuthHttpService } from './http-auth.service'

import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import {
  IDecryptTxDataDto,
  IEncryptTxDataDto,
  IFekeScansDataDataDto,
  IMessageResponseDto,
} from 'src/types'

class ToolsService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  decryptTxData(dto: IDecryptTxDataDto) {
    return this.post<any, IDecryptTxDataDto>(`tools/decrypt-tx`, dto)
  }

  encryptTxData(dto: IEncryptTxDataDto) {
    return this.post<any, IEncryptTxDataDto>(`tools/encrypt-tx`, dto)
  }

  deleteFakeConsumerScans() {
    return this.delete<IMessageResponseDto>(`tools/fake-consumer-scans`)
  }

  getFakeConsumerScansData() {
    return this.get<IFekeScansDataDataDto>(`tools/fake-consumer-scans-data`)
  }
}

export const toolsService = new ToolsService()
export default ToolsService
